export enum EOrientation {
	horizontal = "horizontal",
	vertical = "vertical"
}
